import { useState } from "react";
import PropTypes from "prop-types";
import StepIntroduction from "./StepIntroduction";
import StepBrokerSelection from "./StepBrokerSelection";
import StepSuccess from "./StepSuccess";

const MultiStepModal = ({
  show,
  onHide,
  onSuccess,
  isConnectedPage = false,
}) => {
  const [currentStep, setCurrentStep] = useState(1);

  const handleNextStep = () => {
    setCurrentStep((prev) => Math.min(prev + 1, 3));
  };

  const handlePrevStep = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  const handleSuccess = () => {
    onSuccess();
    onHide();
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <StepIntroduction
            show={show}
            onHide={onHide}
            onNext={handleNextStep}
          />
        );
      case 2:
        return (
          <StepBrokerSelection
            show={show}
            onHide={onHide}
            onBack={handlePrevStep}
            onSuccess={handleSuccess}
            isConnectedPage={isConnectedPage}
          />
        );
      case 3:
        return (
          <StepSuccess show={show} onHide={onHide} onSuccess={handleSuccess} />
        );
      default:
        return null;
    }
  };

  return renderStep();
};

MultiStepModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onSuccess: PropTypes.func,
  isConnectedPage: PropTypes.bool,
};

export default MultiStepModal;
